import { DatePipe } from '@angular/common'
import { AfterViewInit, booleanAttribute, Directive, ElementRef, inject, input, Renderer2 } from '@angular/core'
import { getISOWeek } from 'date-fns'
import { SharedUserService } from '../services'
@Directive({
  selector: '[aoDateWeekNumber]',
  providers: [DatePipe],
})
export class DateWeekNumberDirective implements AfterViewInit {
  private readonly element = inject(ElementRef)
  private readonly renderer = inject(Renderer2)
  private readonly userService = inject(SharedUserService)
  private readonly datePipe = inject(DatePipe)

  /** Date to display (required); nothing is rendered without one */
  readonly aoDateWeekNumber = input.required<string | null | undefined>()

  /** Display time (optional) */
  readonly displayTime = input(false, { transform: booleanAttribute })

  ngAfterViewInit(): void {
    const aoDateWeekNumber = this.aoDateWeekNumber()
    if (!aoDateWeekNumber) return

    const format = this.displayTime()
      ? this.userService.currentUserDateHourFormat
      : this.userService.currentUserDateFormat

    const dateToDisplay = this.datePipe.transform(aoDateWeekNumber, format ?? undefined)

    const weekNumber = getISOWeek(new Date(aoDateWeekNumber))
    const weekText = ` - S${weekNumber}`

    const dateElement = this.renderer.createElement('span')
    const weekElement = this.renderer.createElement('span')

    const dateNode = this.renderer.createText(dateToDisplay ?? '')
    const weekNode = this.renderer.createText(weekText)

    this.renderer.appendChild(dateElement, dateNode)
    this.renderer.appendChild(weekElement, weekNode)
    this.renderer.appendChild(this.element.nativeElement, dateElement)
    this.renderer.appendChild(this.element.nativeElement, weekElement)
  }
}
